import React, { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import { searchQueryState, selectedShipmentState, shipmentSearchSelector } from '../../states/shipment';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import OutlinedInput from '@mui/material/OutlinedInput';

import DeliveryHistoryItem from '../HistoryItem';

function DeliverySearchResult() {
  const shipments = useRecoilValue(shipmentSearchSelector);
  const items = Array.isArray(shipments?.items) ? shipments.items : [];
  return <div>{items.map((shipment) => <DeliveryHistoryItem key={shipment.id} showCustomer={true} showAddress={true} shipment={shipment} />)}</div>;
}

export default function DeliverySearchContainer() {
  const shipment = useRecoilValue(selectedShipmentState);
  const setQuery = useSetRecoilState(searchQueryState);
  const [customQuery, setCustomQuery] = useState('');
  const updateQuery = () => {
    setQuery({ from: 0, size: 15, q: customQuery });
  };
  useEffect(() => {
    if (!shipment) {
      setQuery({ from: 0, size: 15, q: 'NONE' });
    } else {
      const parts = [
        shipment?.customer?.name,
        shipment?.dropoff_address?.street,
        shipment?.dropoff_address?.city,
        shipment?.dropoff_address?.zipcode,
      ].filter(Boolean);
      const q = parts.length > 0 ? parts.join(' ') : 'NONE';
      setQuery({ from: 0, size: 15, q });
      setCustomQuery(q);
    }
  }, [shipment, setQuery, setCustomQuery]);

  return (
    <div style={{ height: 'calc(100% - 4px)', position: 'relative', padding: 0 }}>
      <div style={{ display: 'flex', height: '40px' }}>
        <div style={{ flex: 1 }}>
          <OutlinedInput onKeyDown={(e) => e.key === 'Enter' && updateQuery(e)} fullWidth style={{ height: '40px' }} value={customQuery} onChange={(e) => setCustomQuery(e.target.value)} />
        </div>
        <div>
          <IconButton onClick={updateQuery}>
            <SearchIcon />
          </IconButton>
        </div>
      </div>
      <div style={{ position: 'absolute', padding: '10px', overflow: 'auto', paddingLeft: 0 }}>
        <React.Suspense fallback={<div>Loading...</div>}>
          <DeliverySearchResult />
        </React.Suspense>
      </div>
    </div>
  );
}
